import { getSlider } from 'Utils/BaseSlider';

let sliderInstance = null;

export const slider = {
  name: 'slider',
  inserted: (el, { value }) => {
    sliderInstance = getSlider(el, value);
    sliderInstance.init();
  },
  destroyed() {
    sliderInstance.clear();
  },
};
